const _header = $('#js-header');
const _menuBtn = $('#js-hamburger');
const _navigation = $('#js-navigation');
const _navItem = _navigation.find('a');
const _navigationBg = $('#js-navigationBg');
const _html = $('html');


const _logo = $('#js-logo');


// スクロールでヘッダー固定
function handleHeaderFixed() {
  if (window.scrollY > 0) {
    _header.addClass('is-fixed');
  } else {
    _header.removeClass('is-fixed');
  }
}

$(window).on('scroll resize', handleHeaderFixed);
$(document).ready(handleHeaderFixed);

_menuBtn.click(function() {
	if (window.innerWidth <= 1023) {
		_header.toggleClass('is-open');
		_menuBtn.toggleClass('is-open');
		_navigation.toggleClass('is-open');
		_navigationBg.toggleClass('is-open');
		_html.toggleClass('is-fixed');
		_logo.toggleClass('is-open');
	}
});

_navItem.click(function(){
	if (window.innerWidth <= 1023) {
		_header.toggleClass('is-open');
		_menuBtn.toggleClass('is-open');
		_navigation.toggleClass('is-open');
		_navigationBg.toggleClass('is-open');
		_logo.toggleClass('is-open');
		$('html').removeClass('is-fixed');
	}
});


